import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10a82734&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a82734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10a82734')) {
      api.createRecord('10a82734', component.options)
    } else {
      api.reload('10a82734', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=10a82734&scoped=true&", function () {
      api.rerender('10a82734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/gradeConfig/index.vue"
export default component.exports